export default __webpack_public_path__ + "static/media/granville06.29bec116.jpg";